<template>
<div>
    <v-img :src="require('@/assets/maya/servicios/headers/retrabajos.jpg')" max-height="420" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                Retrabajo / Reworks
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-regular" style="max-width:480px; line-height:1.3">
                <div>Contención Temprana de Producción – Early Production Containment</div>
            </div>

            <div>
                <v-btn small text class="white--text ml-n4 mt-2" @click="$router.push('/servicios')">
                    <div class="d-flex align-center">
                        <v-icon size="12" color="white" class="mr-2 mt-1">fa-arrow-left</v-icon>
                        <div>Regresar a servicios</div>
                    </div>
                </v-btn>
            </div>
        </v-card>
    </v-img>

    <div class="white py-6 px-4 px-sm-0">
        <v-row class="">
            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="1">
                <p>
                    Consiste en la recuperación de componentes, productos y materiales rechazados o que fueron etiquetados como desperdicios.
                </p>

                <p>
                    A través de los procesos de manufactura adicionales que se implementan en estos servicios de retrabajo, se busca corregir las fallas para que puedan ser finalmente aceptados y considerados como material productivo.  
                </p>

                <p>
                    Ya que este servicio está fuera del alcance del proceso original de manufactura, se le considera “retrabajo” pues es un esfuerzo duplicado causado por fallas o daños que surgieron, por ejemplo, durante la transportación del producto o bien, porque no cumplió con la calidad esperada. Otra causa son los posibles defectos en el empaque o en el ensamble.  
                </p>

                <p>
                    La corrección de errores representa un beneficio económico para las industrias ya que así es posible la recuperación de componentes para incorporarlos de nuevo a las líneas de producción, en lugar de desecharlos o reemplazarlos.
                </p>

                <div class="mt-4 primary--text font-weight-bold">Los servicios de retrabajo pueden realizarse:</div>
                <ul>
                    <li>En nuestras instalaciones.</li>
                    <li>En las instalaciones o plantas del proveedor.</li>
                    <li>En las plantas de clientes.</li>
                </ul>

                <div class="mt-4 primary--text font-weight-bold">MSO ofrece, además:</div>
                <ul>
                    <li>Entrenamiento y capacitación.</li>
                    <li>Insumos.</li>
                    <li>Herramientas, equipos de medición, la fabricación de recursos e infraestructura necesarios para estos servicios de retrabajo.</li>
                    <li>Reportes de acuerdo a las necesidades del cliente.</li>
                </ul>
            </v-col>
        </v-row>
    </div>

    <!-- CONTACT FORM -->
    <ContactForm />
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        ContactForm
    },
    metaInfo: {
      title: 'Retrabajo / Reworks'
    }
}
</script>
